import { useEffect } from "react";

import { fetchModelTypeFilters } from "../../../../store/reducer/_searchReducer";

import { getModelTypeSearchFilters } from "../../../../store/selectors";

import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { RequestFilterModelType } from "../../../../services";
import FiltrosLista from "../_filtrosLista";
import Select from "../_select";

import "./index.scss";

interface ModelTypeFilterSectionProps {
  modelType: RequestFilterModelType;
  setModelType: (modelType: RequestFilterModelType) => void;
}

const ModelTypeFilterSection = ({
  modelType,
  setModelType,
}: ModelTypeFilterSectionProps) => {
  const dispatch = useAppDispatch();

  const filters = useAppSelector(getModelTypeSearchFilters);
  const currentFilters = filters?.[modelType] || [];

  useEffect(() => {
    dispatch(fetchModelTypeFilters(modelType as any));
  }, [modelType, dispatch]);

  return (
    <div className="model-type-container">
      <Select
        value={modelType}
        onSelect={(value) => setModelType(value as RequestFilterModelType)}
        placeholder="Selecione o tipo do modelo"
        options={[
          { label: "Petições", value: "peticoes" },
          { label: "Sentenças", value: "sentencas" },
          { label: "Despachos", value: "despachos" },
          { label: "Contratos", value: "contratos" },
          { label: "Pareceres", value: "pareceres" },
          { label: "Denúncias", value: "denuncias" },
          { label: "Todos", value: "all" },
        ]}
      />

      {currentFilters?.length > 0 && (
        <FiltrosLista
          items={currentFilters}
          period={{}}
          onPeriodChange={() => {}}
          isModelTypeFilterList
          modelType={modelType}
        />
      )}
    </div>
  );
};

export default ModelTypeFilterSection;
